export default __webpack_public_path__ + "static/media/intro.40c91c1a.jpg";